import {memo, MouseEvent, useState} from "react";
import {useRelatedClients} from "@/context/RelatedClientProvider";
import {Button, Divider, ListSubheader, Menu, MenuItem} from "@mui/material";
import {FormattedMessage} from "react-intl";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useWatchConcertoStorage} from "@/utils/localStorage";

const heimdallUrl = new URL(window.heimdallApiUrl);

const useName = () => {
    const profile = useWatchConcertoStorage((state) => state.profile);

    let name = profile?.name;

    if (name === undefined) {
        const names = [profile?.family_name, profile?.given_name].filter((n) => n);
        name = names.join(" ");
    }

    return name;
};

export default memo(() => {
    const name = useName();
    const relatedClients = useRelatedClients();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event: MouseEvent) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? "profile-popover" : undefined;

    return (
        <div>
            <Button onClick={handleClick} style={{textTransform: "unset"}} color="primary">
                {name}
                <FontAwesomeIcon size="xs" icon={"chevron-down"} style={{marginLeft: 5}} />
            </Button>
            <Menu id={id} open={open} anchorEl={anchorEl} onClose={handleClose}>
                <MenuItem component="a" href={`${heimdallUrl.protocol}//${heimdallUrl.host}`}>
                    <FormattedMessage id="manage_account" defaultMessage="Manage account" />
                </MenuItem>
                {relatedClients.length > 0 && (
                    <>
                        <Divider style={{margin: "0.2em 0"}} />
                        <ListSubheader
                            style={{
                                textTransform: "uppercase",
                                fontSize: "0.8em",
                                lineHeight: "32px",
                                fontWeight: "bold",
                            }}
                        >
                            <FormattedMessage id="applications" defaultMessage="Applications" />
                        </ListSubheader>
                        {relatedClients.map((item) => (
                            <MenuItem component="a" key={`${item.id}`} href={`${item.url.protocol}//${item.url.host}`}>
                                {item.displayName}
                            </MenuItem>
                        ))}
                    </>
                )}
            </Menu>
        </div>
    );
});
